module.exports = __webpack_public_path__ + "img/Confirmation.039cfd5f.svg";